var PrintElement = require('../util/print-element');

var OrdersPickup = function() {
    var self = this;
    // print & update
    $('.btn-print-update').on('click', function(evt) {
        var $form = $('form.orders-pickup-form');
        var orders = [];
        $form.find('table tbody tr').each(function() {
            var $this = $(this);
            if ($this.find('#flexSwitchCheckDefault_' + $this.attr('data-id'))[0].checked) {
                orders.push($this.attr('data-id'));
            }
        });
        evt.preventDefault();
        $.ajax('/admin/orders/pickup-print', {
            method: 'POST',
            data: {
                _token: $form.find('[name="_token"]').val(),
                action: 'print',
                orders: orders
            }
        }).then(function(response) {
            self.openPrintDialog(response);
        });
        return false;
    });
};

OrdersPickup.prototype = {
    constructor: OrdersPickup,
    openPrintDialog: function(content) {
        var iframe = document.createElement('iframe');
        iframe.classList.add('visually-hidden');
        document.body.append(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(content);
        iframe.contentWindow.document.close();
        iframe.contentWindow.onafterprint = function() {
            iframe.remove();
        };
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
    }
};

module.exports = OrdersPickup;